import React, { FC, PropsWithChildren } from "react";
import {
  ApolloClient,
  ApolloProvider,
  createHttpLink,
  InMemoryCache,
} from "@apollo/client";
import env from "../env";

const createApolloClient = (uri: string) => {
  const httpLink = createHttpLink({ uri });

  return new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
  });
};

const client = createApolloClient(env.GATEWAY_URL!);

export const GraphQLProvider: FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
